if (!customElements.get('quick-add')) {
  customElements.define(
    'quick-add',
    class QuickAdd extends HTMLElement {
      constructor() {
        super();
        this.loading = false;
        this.init();
      }

      init() {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();

          if (this.loading) {
            return;
          }

          // Loading indicator on add to cart button
          this.addToCart.classList.add('btn--loading');
          this.loading = true;

          var data = theme.utils.serialize(this.form);

          fetch(theme.routes.cartAdd, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
            .then(response => response.json())
            .then((data) => {
              if (data.status !== 422) {
                var product = data;
                this.form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  detail: {
                    product: product,
                    addToCartBtn: this.addToCart
                  },
                  bubbles: true
                }));
              }

              this.loading = false;
              this.addToCart.classList.remove('btn--loading');
            })
        });
      }

      get form() {
        return this.querySelector(`form`);
      }

      get addToCart() {
        return this.querySelector(`button[type="submit"]`);
      }
    }
  );
}